<template>
  <v-card class="pa-4">
    <v-card-title primary-title>
      <div>
        <div class="title text-center">Enroll in MFA</div>
      </div>
    </v-card-title>
    <v-card-text>
      <v-card>
        <v-card-text>
          <p>
            Once you click OK below your login account will be tagged as Multi
            Factor Authentication as required.
          </p>
          <p>
            Note: If you have already done this, you can just safely ignore
            this, and hit cancel.
          </p>
          <p>
            The next time you log into this application you will be prompted
            with a screen like this - follow the instructions on screen to
            complete.
          </p>
        </v-card-text>
      </v-card>
    </v-card-text>
    <v-card-text>
      <center>
        <div class="text-center">
          <img src="@/assets/mfa_sample.png" height="400px" />
        </div>
      </center>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" :disabled="loading" @click="onClickSubmit">
        {{ loading ? 'Loading' : 'Ok' }}
      </v-btn>
      <v-btn color="primary" :disabled="loading" @click="closeDialog">
        Cancel
      </v-btn>
    </v-card-actions>
    <v-snackbar color="red" v-model="snackbar" :timeout="1000">
      {{ text }}
    </v-snackbar>
  </v-card>
</template>
<script>
import { mapActions } from 'vuex'
import { EventBus } from '@/plugins/event-bus.js'

export default {
  data() {
    return {
      loading: false,
      snackbar: false,
      text: '',
    }
  },
  methods: {
    ...mapActions('reminders', ['addMFAToUser']),
    closeDialog() {
      EventBus.$emit('toggleMFADialog', false)
    },

    async onClickSubmit() {
      try {
        this.loading = true
        await this.addMFAToUser(this.$auth.user.name)
        this.loading = false
        this.closeDialog()
      } catch (error) {
        this.text = error
        this.loading = false
        this.snackbar = true
      }
    },
  },
}
</script>
